import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from "react-select";

const Onboarding_Candidates = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    from: today,
    to: today,
    exclude_moved: true,
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

 



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/onboarding-candidates",
        {
          from: filters.from,
          to: filters.to,
          exclude_moved: filters.exclude_moved,
          dept_id: filters.dept_id || 0,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data || []);
      setCurrentPage(1);

      toast.success("Candidates loaded!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to load candidates");
    } finally {
      setLoading(false);
    }
  };

  const filteredItems = records.filter((item) =>
    `${item.first_name} ${item.last_name} ${item.job_title} ${item.email} ${item.contact_no}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        <div className="card shadow-sm mb-4">
          <div className="card-header with-elements">
            <span className="card-header-title me-2">Onboarding Candidates Filter</span>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">

                <div className="col-md-4">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="from"
                    value={filters.from}
                    onChange={handleInput}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="to"
                    value={filters.to}
                    onChange={handleInput}
                    required
                  />
                </div>

               

                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Get
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>

        {/* TABLE */}
        <div className="card">
          <div className="card-header">
            <h6 className="text-danger">Onboarding Candidates</h6>
          </div>

          <div className="card-body">

            <div className="d-flex justify-content-between mb-2">
              <div className="d-flex gap-2">
                <DownloadButtons data={filteredItems} filename="Onboarding_Candidates" />
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>

              <input
                type="text"
                className="form-control form-control-sm"
                style={{ width: "200px" }}
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>CANDIDATE NAME</th>
                      <th>EMAIL</th>
                      <th>PHONE</th>
                      <th>JOB TITLE</th>
                      <th>RECRUIT ON</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.first_name} {row.last_name}</td>
                          <td>{row.email}</td>
                          <td>{row.contact_no}</td>
                          <td>{row.job_title}</td>
                          <td>{row.recruit_on}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-danger">
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />

          </div>
        </div>
      </div>
    </>
  );
};

export default Onboarding_Candidates;
